var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key",class:_vm.myclasses,style:(_vm.mystyles),attrs:{"id":_vm.myid,"title":_vm.displayName}},[_vm._v(_vm._s(_vm.displayName))])}
var staticRenderFns = []

export { render, staticRenderFns }